import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

export const CreateNotes = () => {
  const [post, setPost] = useState({
    title: "",
    content: "",
    image: "",
    username: window.localStorage.getItem("username"),
    datetime: new Date().toLocaleString("en-US", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }),
    tag: [],
  });

  const AddTag = () => {
    setPost({ ...post, tag: [...post.tag, ""] });
  };

  const handleChange = async (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    setPost({ ...post, [name]: value });
  };

  const TAGChange = async (event, index) => {
    event.preventDefault();
    const { value } = event.target;
    const Tags = [...post.tag];
    Tags[index] = value;
    setPost({ ...post, tag: Tags });
  };

  const handleSubmit = async (event) => {
    const Notifications = (msg) => toast(msg);
    event.preventDefault();
    try {
      await axios.post("https://blogapi21.onrender.com/posts", post);
      Notifications("Successfully Posted");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="flex justify-center align-middle items-center">
        <div className="flex justify-center align-middle mt-[1.5%] w-screen">
          <div className="card flex-shrink-0 w-full max-w-sm shadow-2xl bg-neutral">
            <div className="card-body">
              <div className="form-control">
                <label className="label">
                  <span className="label-text text-neutral-content">Title</span>
                </label>
                <input
                  type="text"
                  placeholder="Title of Post"
                  className="input input-bordered"
                  id="title"
                  name="title"
                  onChange={handleChange}
                />
              </div>
              <div className="form-control">
                <label className="label">
                  <span className="label-text text-neutral-content">Post</span>
                </label>
                <textarea
                  className="textarea textarea-neutral textarea-bordered"
                  id="content"
                  placeholder="Let your thoughts flow..."
                  name="content"
                  onChange={handleChange}
                ></textarea>
              </div>
              <div className="form-control">
                <label className="label">
                  <span className="label-text text-neutral-content">
                    Image Link
                  </span>
                </label>
                <input
                  type="text"
                  placeholder="Image Link"
                  className="input input-bordered"
                  id="image"
                  name="image"
                  onChange={handleChange}
                />
              </div>
              <div className="form-control">
                <label className="label">
                  <span className="label-text text-neutral-content">Tags</span>
                </label>
                <button
                  className="btn btn-secondary text-secondary-content mb-5"
                  onClick={AddTag}
                >
                  Add Tag
                </button>
                {post.tag.map((tag, index) => (
                  <input
                    key={index}
                    type="text"
                    name="tag"
                    value={tag}
                    onChange={(event) => TAGChange(event, index)}
                    className="input input-bordered my-2"
                  />
                ))}
              </div>
              <div className="form-control mt-6 flex w-full">
                <div className="flex w-full justify-center">
                  <button
                    type="submit"
                    className="btn btn-neutral-content text-neutral-content"
                    onClick={handleSubmit}
                  >
                    Create Post
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
